export default {
      id: "book-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#book",
      toString: function () {
        return this.url;
      }
    }